import { createContext } from 'react';

// Hôte DOM des sections de réglage (cf. BoxFormControlsPortal) pour un sous-arbre
// qui recouvre le panel de droite, comme l'éditeur plein écran de forme. Null :
// le panel de droite habituel.
export const FormControlsPortalContext = createContext(null);
